import initState from '@shared/init-state-v0.1.0';
import type { BaseJsProps } from '@shared/node-v1.0.0';
import type { JsNodeDef } from '@shared/node-v1.0.0';
import { getPortDef } from '@shared/port-v1.0.0';
import { validateDeleteScheme } from './validtaion';
import type { DeleteScheme } from './validtaion';

export type Props = BaseJsProps & {
	deleteScheme?: DeleteScheme;
	replicationData: boolean;
};

export default {
	hashTag: '#experimental',
	module: { dynamic: import('../component') },
	inNode: {
		inputs: [
			getPortDef({
				name: 'deleteScheme',
				displayName: 'Delete scheme',
				group: 'Params',
				type: 'array',
				validate: (p: Props) => (p.deleteScheme ? validateDeleteScheme(p) : true),
			}),
			getPortDef({
				name: 'replicationData',
				displayName: 'Replication data',
				group: 'Params',
				type: 'boolean',
				default: true,
			}),
			getPortDef({
				name: 'delete',
				displayName: 'Delete',
				group: 'Signals',
				type: 'signal',
			}),
		],
		outputs: [
			getPortDef({ name: 'deleting', displayName: 'Deleting', group: 'States', type: 'boolean' }),
			getPortDef({ name: 'deleted', displayName: 'Deleted', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'data', displayName: 'Data', group: 'Data', type: 'object' }),
		],
	},
	afterNode: {
		getInspectInfo: (p: Props, outProps) => [
			{ type: 'text', value: '=== Scheme ===' },
			{ type: 'value', value: p.deleteScheme },
			outProps.data && { type: 'text', value: '=== Data ===' },
			outProps.data && { type: 'value', value: outProps.data },
		],
	},
	beforeComponent: {
		initialize: async () => {
			await initState('initialized');
		},
	},
	disableCustomProps: true,
} satisfies JsNodeDef;
